import React, { useState } from 'react';
import { InstantSearch, Configure, Index } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

import { noEmptySearchClient } from 'components/essentials/AlgoliaSearchClient';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import classNames from 'classnames';
import useToggleIsSearchOpen from 'global-state/isSearchOpen/useToggleIsSearchOpen';
import useAllOptions from 'data-hooks/useAllOptions';
import JBSearchBox from 'components/consumer/consumer-search/components/JBSearchBox';
import {
  SearchResults,
  CategoryHits,
  StaticPageHits,
  ResultsByCategory,
  ProductResultsMobile,
} from '../../commons/helpers';

const InstantSearchMobile = ({
  autoFocus,
  placeholder = 'What can we help you find?',
  setSearchEventParams,
  toggleMenu,
  variant = 'default',
  toggleMobileSearchBar,
}) => {
  const [lastQuery, setLastQuery] = useState('');
  const [lastQueryTopThreeRes, setLastQueryTopThreeRes] = useState([]);
  const [inactive, setInactive] = useState(false);
  const toggleIsSearchOpen = useToggleIsSearchOpen();
  const allOptionsData = useAllOptions();
  return (
    <InstantSearch
      searchClient={noEmptySearchClient}
      indexName={ALGOLIA_INDEX_NAME.PRODUCTS}
    >
      <Configure
        hitsPerPage={3}
        facets={['type', 'option_name']}
        numericFilters={['item_availability<2', 'visibility>0', 'visibility<4']}
      />
      <JBSearchBox
        autoFocus={autoFocus}
        inMobileNav
        isActive={autoFocus}
        placeholder={placeholder}
        setSearchEventParams={setSearchEventParams}
        toggleMenu={toggleMenu}
        toggleSearchOpen={toggleIsSearchOpen}
        variant="InstantSearchMobile"
        toggleMobileSearchBar={toggleMobileSearchBar}
      />
      <SearchResults>
        <div
          className={classNames({
            'bg-white z-[4] pb-36': variant === 'consumer-header-mobile',
          })}
        >
          <div className="text-[.8em] flex w-full mx-[3.333vw] my-0 text-sm flex-col m-0 font-bold">
            <ProductResultsMobile
              isInstantSearch
              layout="minimal"
              lastQuery={lastQuery}
              setLastQuery={setLastQuery}
              inactive={inactive}
              setInactive={setInactive}
              lastQueryTopThreeRes={lastQueryTopThreeRes}
              setLastQueryTopThreeRes={setLastQueryTopThreeRes}
              toggleSearchOpen={toggleIsSearchOpen}
              toggleMenu={toggleMenu}
              allOptionsData={allOptionsData}
            />
            <Index indexName="categories">
              <Configure
                hitsPerPage={5}
                numericFilters={['fk_store_id=1']}
                facetFilters={['is_searchable:1']}
              />
              <CategoryHits
                toggleSearchOpen={toggleIsSearchOpen}
                variant="mobile"
              />
            </Index>

            <div className="min-w-[20%] flex-[0_1_20%] pl-[30px] h-full p-0 instant-search-form__each-results-container-non-padded">
              <Index indexName="static_pages_new">
                <Configure
                  hitsPerPage={3}
                  numericFilters={[
                    'is_active=1',
                    'show_in_search=1',
                    'fk_store_id=1',
                  ]}
                />
                <StaticPageHits
                  toggleSearchOpen={toggleIsSearchOpen}
                  variant="mobile"
                />
              </Index>
              <div className="[border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10 p-0 min-h-[auto] mb-2 w-full border-0 order-[-1]">
                <ResultsByCategory
                  toggleSearchOpen={toggleIsSearchOpen}
                  variant="mobile"
                />
              </div>
            </div>
          </div>
        </div>
        <Index indexName="reviews">
          <Configure facets={['*']} numericFilters="" facetFilters="" />
        </Index>
        <Index indexName="customer_photos">
          <Configure facets={['*']} numericFilters="" />
        </Index>
      </SearchResults>
    </InstantSearch>
  );
};

InstantSearchMobile.propTypes = {
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  setSearchEventParams: PropTypes.func,
  toggleMenu: PropTypes.func,
  variant: PropTypes.string,
  toggleMobileSearchBar: PropTypes.func,
};

export default InstantSearchMobile;
